const strings = {
  en: {
    sectionLabelAbout: 'ABOUT US',
    heroTitlePrefix: 'Building the Future of ',
    heroTitleAccent: 'Sales Intelligence',
    heroTitleSuffix: ' in Southeast Asia',
    heroSubtitle: 'SAPOT AI is built by Dataverse Sdn Bhd — a team passionate about using artificial intelligence to transform how sales teams perform, learn, and grow.',
    heroImageAlt: 'SAPOT AI Team',
    missionHeadingPrefix: 'Our ',
    missionHeadingAccent: 'Mission',
    missionPara1: 'We believe every sales conversation holds untapped intelligence. SAPOT AI exists to capture that intelligence and turn it into structured, actionable insights that help sales teams perform consistently at their best.',
    missionPara2: 'Our platform records, transcribes, and analyzes offline and in-person sales conversations — enabling organizations to standardize high-performing sales behaviors and replicate success across teams.',
    storyHeadingPrefix: 'Our ',
    storyHeadingAccent: 'Story',
    storyPara1: 'Starting as Mampu AI, we built chatbots and AI assistants for Malaysian businesses. Through our work, we discovered that the biggest gap in sales wasn\u2019t online — it was in the offline, face-to-face conversations that drive real revenue.',
    storyPara2: 'That insight led to SAPOT AI — the Sales Assistant Performance Optimization Tool. Today, we serve 13 companies with over 1,300 conversations analyzed, helping sales teams across Malaysia transform how they sell.',
    sectionLabelValues: 'OUR VALUES',
    valuesTitlePrefix: 'What ',
    valuesTitleAccent: 'Drives',
    valuesTitleSuffix: ' Us',
    sectionLabelLeadership: 'LEADERSHIP',
    teamTitlePrefix: 'The People Behind ',
    teamTitleAccent: 'SAPOT AI',
    linkedin: 'LinkedIn',
    ctaTitle: 'Join Us on Our Mission',
    ctaSubtitle: "We're always looking for talented people who share our passion for AI and sales innovation.",
    ctaButton: 'Get in Touch',
  },
  zh: {
    sectionLabelAbout: '关于我们',
    heroTitlePrefix: '打造东南亚',
    heroTitleAccent: '销售情报',
    heroTitleSuffix: '的未来',
    heroSubtitle: 'SAPOT AI 由 Dataverse Sdn Bhd 倾力打造——我们是一支热衷于运用人工智能重塑销售团队表现、学习与成长方式的团队。',
    heroImageAlt: 'SAPOT AI 团队',
    missionHeadingPrefix: '我们的',
    missionHeadingAccent: '使命',
    missionPara1: '我们相信，每一次销售对话中都蕴藏着尚未被挖掘的情报。SAPOT AI 的使命正是捕捉这些情报，并将其转化为结构化、可执行的洞察，帮助销售团队始终保持最佳表现。',
    missionPara2: '我们的平台能够录制、转写并分析线下及面对面的销售对话——帮助企业将高效能的销售行为标准化，并在团队间复制成功经验。',
    storyHeadingPrefix: '我们的',
    storyHeadingAccent: '故事',
    storyPara1: '我们最初以 Mampu AI 起步，为马来西亚本地企业打造聊天机器人与 AI 助手。在实际工作中，我们发现销售领域最大的空白并不在线上——而在真正带来营收的线下、面对面的对话中。',
    storyPara2: '正是这份洞察催生了 SAPOT AI——Sales Assistant Performance Optimization Tool（销售助理绩效优化工具）。如今，我们已服务 13 家企业，分析了超过 1,300 次对话，帮助马来西亚各地的销售团队革新销售方式。',
    sectionLabelValues: '我们的价值观',
    valuesTitlePrefix: '驱动',
    valuesTitleAccent: '我们',
    valuesTitleSuffix: '前行的力量',
    sectionLabelLeadership: '领导团队',
    teamTitlePrefix: 'SAPOT AI',
    teamTitleAccent: '背后的团队',
    linkedin: 'LinkedIn',
    ctaTitle: '加入我们，共赴使命',
    ctaSubtitle: '我们始终在寻找与我们一样对 AI 与销售创新充满热情的优秀人才。',
    ctaButton: '联系我们',
  },
};

export default strings;
